import HomeTransactions from 'components/activity/transactions/main/containers/HomeTransactions';
import Transactions from 'components/activity/transactions/main/containers/TransactionsContainer';
import PendingTransactionsList from '../../activity/transactions/main/presentational/PendingTransactionsList';
import { RouteConfig } from '../type';

const activityRoutes: RouteConfig[] = [
    { path: '', element: <HomeTransactions />, pageTitle: 'Home' },
    { path: '/activity/transactions', element: <Transactions />, pageTitle: 'Transactions' },
    {
        path: '/activity/pending',
        element: <PendingTransactionsList />,
        pageTitle: 'Pending Transactions',
    },
];

export default activityRoutes;
